import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormErrorHandler {

  constructor() { }

  hasError(form: FormGroup, controlName: string, errorCode?: string) {
    const control = form.get(controlName);
    const errors = control.errors;
    const error = errorCode && errors ? errors[errorCode] : null;

    return (errorCode ? error : !control.valid) && (control.dirty || control.touched);
  }

  hasGroupError(form: FormGroup, errorCode?: string) {
    const errors = form.errors;
    const error = errorCode && errors ? errors[errorCode] : null;

    return (errorCode ? error : !form.valid) && (form.dirty || form.touched);
  }

  hasArrayError(form: FormGroup, parentName: string, index: number, controlName: string, errorCode?: string) {
    const parent = form.get(parentName) as FormArray;
    const control = parent.at(index).get(controlName);
    const errors = control.errors;
    const error = errorCode && errors ? errors[errorCode] : null;
    return (errorCode ? error : !control.valid) && (control.touched);
  }

}
